import { render } from "./aboutModal.vue?vue&type=template&id=62c08f48&scoped=true"
import script from "./aboutModal.vue?vue&type=script&lang=js"
export * from "./aboutModal.vue?vue&type=script&lang=js"

import "./aboutModal.vue?vue&type=style&index=0&id=62c08f48&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-62c08f48"

export default script